function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110px",
    height: "110px",
    viewBox: "0 0 110 110",
    enableBackground: "new 0 0 110 110",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.15,58.55c-1.337-1.55-2.942-2.691-4.819-3.426c-1.611-0.629-3.654-1.261-6.133-1.895V39.361 c2.745,0.124,5.418,0.64,8.02,1.539c0.387,0.154,0.697,0.232,0.93,0.232c0.696,0,1.258-0.251,1.684-0.756 c0.424-0.502,0.638-1.063,0.638-1.685c0-1.161-0.542-1.933-1.625-2.322c-2.924-1.082-6.139-1.708-9.646-1.871v-7.036 c0-1.341-1.088-2.429-2.43-2.429s-2.43,1.088-2.43,2.429v7.16c-1.943,0.232-3.68,0.71-5.207,1.428 c-2.264,1.063-3.977,2.497-5.138,4.295c-1.161,1.801-1.741,3.804-1.741,6.009c0,2.516,0.696,4.53,2.09,6.039 c1.393,1.509,3.059,2.64,4.994,3.396c1.368,0.535,3.034,1.083,5.002,1.644v13.616c-3.164-0.256-6.166-1.018-9.008-2.284 c-0.349-0.154-0.719-0.232-1.105-0.232c-0.695,0-1.269,0.24-1.711,0.727c-0.445,0.482-0.67,1.053-0.67,1.711 c0,0.506,0.154,0.978,0.465,1.423s0.696,0.765,1.164,0.958c3.425,1.482,7.045,2.371,10.865,2.674v6.508 c0,1.342,1.088,2.43,2.43,2.43s2.43-1.088,2.43-2.43v-6.469c2.168-0.164,4.125-0.626,5.871-1.379 c2.243-0.967,3.988-2.311,5.227-4.033c1.236-1.722,1.857-3.669,1.857-5.836C70.153,62.186,69.483,60.096,68.15,58.55z  M52.339,52.009c-0.762-0.214-1.434-0.427-2.014-0.629c-1.375-0.486-2.516-1.164-3.426-2.033c-0.91-0.872-1.363-2.003-1.363-3.396 c0-2.092,0.959-3.717,2.875-4.878c1.115-0.675,2.424-1.155,3.928-1.436V52.009z M57.198,71.038V58.754 c1.299,0.367,2.367,0.694,3.201,0.986c1.277,0.445,2.352,1.053,3.221,1.827c0.872,0.775,1.307,1.741,1.307,2.902 C64.927,68.352,62.349,70.544,57.198,71.038z",
    id: "id_107",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.004,0C24.678,0,0,24.678,0,55.004C0,85.331,24.678,110,55.004,110S110,85.331,110,55.004C110,24.678,85.33,0,55.004,0 z M55.004,103.568c-26.781,0-48.564-21.793-48.564-48.564c0-26.781,21.783-48.564,48.564-48.564s48.564,21.783,48.564,48.564 C103.568,81.775,81.785,103.568,55.004,103.568z",
    id: "id_108",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar_icon.f830657c6e55318907c6c8b910213567.svg";
export { ForwardRef as ReactComponent };